module.exports = __webpack_public_path__ + "img/pic.520b1e32.png";